import { render, staticRenderFns } from "./viewPolicy.vue?vue&type=template&id=e0f25e54&scoped=true"
import script from "./viewPolicy.vue?vue&type=script&lang=js"
export * from "./viewPolicy.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e0f25e54",
  null
  
)

export default component.exports